/* eslint-disable */
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
const Config = require('./conf');

const moment = extendMoment(Moment);

export const Key = {
  GOOGLE_MAP_PLATFORM: 'AIzaSyAUfFmbrtQRTVjdOzB8lg7krVi8bVg2HpU'
};


// HACKs: The functions below are a suboptimal way to map legacy data and they need to be moved to the database
export const brandedCustomerType = type => {
  if (['DoorSTEPOpen', 'DoorSTEPBook', 'AON'].includes(type)) return 'HOME';
  if (type === 'STEP') return 'HUB: Camden phase 1';
  if (type === 'SmartSTEP') return 'HUB: Brent';
  if (type === 'Barnet') return 'HUB: Barnet phase 1';
  if (type === 'Barnet Phase 2') return 'HUB: Barnet phase 2';
  if (type === 'Harrow') return 'HUB: Harrow';
  if (type === 'Bexley') return 'HUB: Bexley';
  if (type === 'Camden Phase 2') return 'HUB: Camden phase 2';
  return type;
};

export const phalanxIsHectorAON = phalanx => {
  return phalanx?.reference === 'aon_l000101_cs_01';
};

export const isAON = customer => {
  if (!customer) return null;

  return ['DoorSTEPOpen', 'DoorSTEPBook', 'AON'].includes(customer.customer_type);
};

export const isAONorConvertingtoAON = customer => {
  if (!customer) return null;

  // In the process of converting from HUB to AON?
  if (
    customer.customer_conversion_status === 'EOI_NOTIFIED' ||
    customer.customer_conversion_status === 'EOI_INPROGRESS'
  )
    return true;

  return ['DoorSTEPOpen', 'DoorSTEPBook', 'AON'].includes(customer.customer_type);
};

export const isHUB = customer => {
  if (!customer) return null;
  return ['STEP', 'SmartSTEP', 'Barnet', 'Barnet Phase 2', 'Harrow', 'Bexley', 'Camden Phase 2'].includes(customer.customer_type);
};

export const getLocalAuthorityInfo = customer => {
  let name = '';
  let description = '';

  if (customer?.customer_type === 'SmartSTEP') {
    name = 'Brent';
    description = 'The London Borough of Brent';
  } else if (customer?.customer_type === 'STEP' || customer?.customer_type === 'Camden Phase 2') {
    name = 'Camden';
    description = 'The London Borough of Camden';
  } else if (customer?.customer_type === 'Barnet' || customer?.customer_type === 'Barnet Phase 2') {
    name = 'Barnet';
    description = 'The London Borough of Barnet';
  } else if (customer?.customer_type === 'Harrow') {
    name = 'Harrow';
    description = 'The London Borough of Harrow';
  } else if (customer?.customer_type === 'Harrow') {
    name = 'Bexley';
    description = 'The London Borough of Bexley';
  }

  return {
    name: name,
    description: description
  };
};

export const getOrionReporter = userName => {
  // TDTODO how do we get this from ORION?
  if (userName === 'carol') return 'Carol Wilson';
  if (userName === 'sandy') return 'Sandy Thom';
  if (userName === 'tom') return 'Tom Dalziel';
  if (userName === 'hugh') return 'Hugh Mackenzie';
  if (userName === 'ian') return 'Ian Mackenzie';
  if (userName === 'allan') return 'Allan Murray';
  if (userName === 'robbie') return 'Robbie Murray';
  if (userName === 'paul') return 'Paul Horn';
  if (userName === 'sam') return 'Sam Kindred';
  if (userName === 'ash') return 'Ashley Thomson';
  if (userName === 'james') return 'James Spark';
  if (userName === 'dave') return 'Dave Moles';
  if (userName === 'lou') return 'Louise Doig';
  if (userName === 'becks') return 'Rebecca Leach';
  if (userName === 'melissa@trojanenergyltd.com') return 'Melissa Samuel';
  if (userName === 'ryan') return 'Ryan Harris-Tench';
  if (userName === 'daniel@trojanenergyltd.com') return 'Daniel Campion';
  if (userName === 'dina@trojanenergyltd.com') return 'Dina Feseha';
  if (userName === 'christina@trojanenergyltd.com') return 'Christina Samuel';
  if (userName === 'richie') return 'Richie Brown';
  if (userName === 'reh') return 'Reh Soe';
  if (userName === 'leanne@trojanenergyltd.com') return 'Leanne Murray';
  if (userName === 'abdi@trojanenergyltd.com') return 'Abdirizak Bedel';
  if (userName === 'kadeem@trojanenergyltd.com') return 'Kadeem Francis';
  if (userName === 'mark') return 'Mark McCormick';
  if (userName === 'joel') return 'Joel Thomas';
  if (userName === 'donald') return 'Donald Carnegie';
  return 'Alert';
};

// Utilty functions

export const hubCustomerOnboarded = customer => {
  let onboarded =
    customer.user_name.length &&
    customer.email.length &&
    customer.forename.length &&
    customer.surname.length &&
    // customer.address_city.length &&
    customer.address_line1.length &&
    customer.address_postcode.length &&
    (customer.mob_tel_no.length || customer.home_tel_no.length) &&
    customer.user_name.length;

  onboarded = onboarded !== 0;
  localStorage.setItem('customerOnboarded', onboarded);
  return onboarded;
};

export const hubAccountOnboarded = account => {
  let onboarded =
    account.card_name?.length &&
    // account.card_expiry?.length &&
    account.card_last4_digits?.length;

  onboarded = onboarded !== 0;
  localStorage.setItem('accountOnboarded', onboarded);
  return onboarded;
};

export const aonCustomerOnboarded = customer => {
  let onboarded =
    customer.user_name.length &&
    customer.email.length &&
    customer.forename.length &&
    customer.surname.length &&
    // customer.address_city.length &&
    customer.address_line1.length &&
    customer.address_postcode.length &&
    // (customer.mob_tel_no.length || customer.home_tel_no.length) &&
    customer.user_name.length;

  onboarded = onboarded !== 0;
  localStorage.setItem('customerOnboarded', onboarded);
  return onboarded;
};

export const aonAccountOnboarded = (customer, account) => {
  let onboarded =
    account.card_name.length &&
    // account.card_expiry.length &&
    account.card_last4_digits.length &&
    account.stripe_connect_onboarded;

  onboarded = onboarded !== 0;
  localStorage.setItem('accountOnboarded', onboarded);
  return onboarded;
};

export const chargingTypeOptions = [
  { text: 'Plug and play', value: 'Fastest' },
  { text: 'Delayed charging', value: 'Cheapest' },
  { text: 'Specific times', value: 'Timed'}
];

export const offPeakOnlyOptions = [
  { text: 'Continue charging after low price period ends', value: false },
  { text: 'Only charge during the low price period', value: true }
];

export const getLocalStorage = (name, default_) => {
  const value = localStorage.getItem(name);
  return value === null ? default_ : value;
};

export const cipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);

  return text => text.split('')
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join('');
};

export const decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
    .map(hex => parseInt(hex, 16))
    .map(applySaltToChar)
    .map(charCode => String.fromCharCode(charCode))
    .join('');
};

const obfuscateFn = cipher('A9gLVg_OvZG#U8xCLbWIsa9');
const elucidateFn = decipher('A9gLVg_OvZG#U8xCLbWIsa9');

export const obfuscate = (lsName, lsValue) => {
  sessionStorage.setItem(lsName, obfuscateFn(lsValue));
};

export const elucidate = lsName => {
  let lsValue = sessionStorage.getItem(lsName);
  if (!lsValue) return null;
  return elucidateFn(lsValue);
};

export const setArrayItem = (arr, idx, val) => {
  if (idx === undefined) {
    return arr.concat(val);
  }
  while (arr.length < idx) {
    arr.push(null);
  }
  const before = arr.slice(0, idx);
  const after = arr.slice(idx + 1);
  return [...before, val, ...after];
};

export const removeArrayItem = (arr, idx) => {
  const before = arr.slice(0, idx);
  const after = arr.slice(idx + 1);
  return [...before, ...after];
};

export const makeRequest = async (method, url) => {
  return new Promise(function(resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function() {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
    xhr.send();
  });
};

export const googleApiAddressRequest = address =>
  makeRequest(
    'GET',
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address
      .replace(/ /g, '+')
      .replace(/#/g, '')}&key=${Key.GOOGLE_MAP_PLATFORM}`
  );

export const geoLocateAddress = async address => {
  const response = await googleApiAddressRequest(address);
  return response.status !== 'OK'
    ? [null, null]
    : [
        response.results[0].geometry.location.lat,
        response.results[0].geometry.location.lng
      ];
};

export const getPostcodeFromAddress = async address => {
  const response = await googleApiAddressRequest(address);
  return response.status !== 'OK'
    ? null
    : (
        response.results[0].address_components.find(({ types }) =>
          types.includes('postal_code')
        ) || {}
      ).long_name;
};

export const getTimeZoneFromLatLong = async (latitude, longitude) => {
  const response = await makeRequest(
    'GET',
    `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=1458000000&key=${Key.GOOGLE_MAP_PLATFORM}`
  );
  if (response.status !== 'OK') {
    return null;
  }
  return response.timeZoneId;
};

export const customerDetailUrl = (customer, supportingCustomers) => {
  let url;
  if (customer && customer.id) {
    url = `/customer/${customer.id}`;
  } else if (customer && customer.name) {
    const customerDetails = Array.isArray(supportingCustomers)
      ? supportingCustomers.find(({ name }) => name === customer.name)
      : undefined;
    if (customerDetails && customerDetails.id) {
      url = `/customer/${customerDetails.id}`;
    }
  }
  return url;
};

export const customerStageName = (customer, supportingCustomers) => {
  let stageName;
  if (customer && customer.id) {
    const customerDetails = Array.isArray(supportingCustomers)
      ? supportingCustomers.find(({ id }) => id === customer.id)
      : undefined;
    stageName = customerDetails ? customerDetails.name : '';
  } else if (customer && customer.name) {
    const customerDetails = Array.isArray(supportingCustomers)
      ? supportingCustomers.find(({ name }) => name === customer.name)
      : undefined;
    stageName = customerDetails ? customerDetails.name : customer.name;
  }
  return stageName;
};

export const dateISOtoUS = date => {
  const chunks = date.split('-');
  const year = chunks[0];
  const month = chunks[1];
  const day = chunks[2];
  return month + '-' + day + '-' + year;
};

export const dateFromTimestamp = date =>
  moment(date, 'YYYY-MM-DDTHH:mm:ss,Z').format('DD.MM.YYYY');

export const dayFromDate = date =>
  moment(date, 'YYYY-MM-DDTHH:mm:ss,Z').format('ddd');

export const timeFromDate = date =>
  moment(date, 'YYYY-MM-DDTHH:mm:ss,Z').format('HH:mm');

export const hoursBetweenDates = (date1, date2) =>
  moment
    .duration(
      moment(date2, 'YYYY-MM-DDTHH:mm:ss,Z').diff(
        moment(date1, 'YYYY-MM-DDTHH:mm:ss,Z')
      )
    )
    .hours();

export const nextDateFromDay = day => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayIdx = days.indexOf(day);
  const today = moment().isoWeekday();

  return today <= dayIdx
    ? moment()
        .isoWeekday(dayIdx)
        .format('YYYY-MM-DD')
    : moment()
        .add(1, 'weeks')
        .isoWeekday(dayIdx)
        .format('YYYY-MM-DD');
};

export const addHoursToDateTime = (date, time, hours) => {
  const datetime = moment(
    `${date}T${time}:00:00,Z`,
    'YYYY-MM-DDTHH:mm:ss,Z'
  ).add(hours, 'hours');

  return [datetime.format('YYYY-MM-DD'), datetime.format('HH:mm')];
};

export const profileUrl = ({ customerId }) =>
  (!!customerId && `/customer/${customerId}`) || '/';

export const getMoment = ({ date, rawFormat = 'YYYY-MM-DD' }) =>
  moment.isMoment(date) ? date : moment(date, rawFormat);

export const getMomentDateTime = ({
  datetime,
  rawFormat = 'YYYY-MM-DD HH:mm:ss'
}) => (moment.isMoment(datetime) ? datetime : moment(datetime, rawFormat));

export const displayTimezone = timezone => moment.tz(timezone).format('z');

export const displayDate = ({ date, rawFormat, format = 'ddd MMM D, YYYY' }) =>
  getMoment({ date, rawFormat }).format(format);

export const displayTime = ({
  time,
  timeEnd,
  timezone,
  rawFormat = 'HH:mm:ss a',
  format
}) => {
  const start = getMoment({ date: time, rawFormat });
  const formattedStart = start.format(
    format ? format : `${start.minutes() ? 'h:mm' : 'h'}a`
  );
  if (timeEnd) {
    const end = getMoment({ date: timeEnd, rawFormat });
    const formattedEnd = end.format(
      format ? format : `${end.minutes() ? 'h:mm' : 'h'}a`
    );
    return `${formattedStart} to ${formattedEnd} ${displayTimezone(timezone)}`;
  } else {
    return `${formattedStart} ${displayTimezone(timezone)}`;
  }
};

export const localDateTimeToDBUTC = (localDate, localTime) => {
  if (!localDate || !localTime) return null;

  const localDateTime = localDate + 'T' + localTime + ':00';
  return (
    moment(localDateTime)
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss') + ',Z'
  );
};

export const dbUTCDatetimeToLocal = dbUtcTimestamp =>
  dbUtcTimestamp
    ? moment
        .utc(dbUtcTimestamp.replace('T', ' ').split(',')[0])
        .local()
        .format()
        .replace('T', ' @ ')
        .split('+')[0]
        .slice(0, -3)
    : '';

export const dbUTCDatetimeToLocal2 = dbUtcTimestamp => {
  if (!dbUtcTimestamp) return '';

  return moment
    .utc(dbUtcTimestamp.replace('T', ' ').split(',')[0])
    .local()
    .format()
    .replace('T', ' @ ')
    .split('+')[0];
};

export const dbUTCDatetimeToLocalTime = dbUtcTimestamp =>
  moment
    .utc(dbUtcTimestamp.replace('T', ' ').split(',')[0])
    .local()
    .format('HH:mm:ss');

export const dbUTCTimeToLocal = dbUtcTimestamp =>
  moment
    .utc(dbUtcTimestamp.replace('T', ' ').split(',')[0])
    .local()
    .format()
    .replace('T', ' @ ')
    .split('+')[0];

export const dbUTCTimeToLocal2 = dbUtcTimestamp =>
  moment
    .utc(dbUtcTimestamp.replace('T', ' ').split(',')[0])
    .local()
    .format('MMM D @ HH:mm');

export const dbUTCTimeToLocalDiff = (dbUtcTimestamp1, dbUtcTimestamp2) => {
  const diff = moment
    .utc(dbUtcTimestamp2, 'YYYY-MM-DDTHH:mm:ss,Z')
    .diff(moment.utc(dbUtcTimestamp1, 'YYYY-MM-DDTHH:mm:ss,Z'));
  return moment.utc(diff).format('HH:mm:ss');
};

export const isTodayOrAfter = date =>
  !date
    ? false
    : getMoment({ date, rawFormat: 'YYYY-MM-DD' }).isSameOrAfter(
        moment()
          .subtract(1, 'days')
          .hour(23)
          .minute(59)
          .second(59)
      );

export const isDateAfter = (date1, date2) => {
  const date1Date = getMoment({
    date: date1,
    rawFormat: 'YYYY-MM-DDTHH:mm:ss,Z'
  });
  const date2Date = getMoment({
    date: date2,
    rawFormat: 'YYYY-MM-DDTHH:mm:ss,Z'
  });
  return date1Date.isSameOrAfter(date2Date);
};

export const isTimeBefore = ({ time, time2, rawFormat = 'HH:mm:ss a' }) => {
  if (!time) return false;
  if (!time2) return true;
  return getMoment({ date: time, rawFormat }).isBefore(
    getMoment({ date: time2, rawFormat })
  );
};

export const adjustDate = (date, days, weeks, months, years) =>
  moment(date)
    .add(days + weeks * 7, 'days')
    .add(months, 'months')
    .add(years, 'years');

export const fetchListQuery = {
  regionArr: false,
  page: 1,
  size: 10000,
  orderBy: false,
  orderDirection: false
};

export const customerTelApprovedFilter = (
  { telApproved, id },
  currentUserCustomerId,
  allowNonTelUsers
) => (id ? id === currentUserCustomerId : allowNonTelUsers) || telApproved;

export const customerActiveFilter = (
  { customerStatus, id },
  currentUserCustomerId,
  allowNonTelUsers
) => (id ? id === currentUserCustomerId : allowNonTelUsers) || customerStatus;

export const customerHydraFilter = (customer, selectedHydraId) =>
  !selectedHydraId ||
  selectedHydraId === customer.regionId ||
  (Array.isArray(customer.performingHydras) &&
    customer.performingHydras.includes(selectedHydraId));

export const customerHydraAreaFilter = (
  customer,
  regions,
  { territory, area }
) =>
  !territory ||
  !area ||
  regions.find(
    ({ id, regionTerritory, regionArea }) =>
      (id === customer.regionId ||
        (Array.isArray(customer.performingHydras) &&
          customer.performingHydras.includes(id))) &&
      regionTerritory === territory &&
      regionArea === area
  );

export const customerActiveHydraFilter = (
  customer,
  regions,
  currentUserCustomerId
) =>
  customer.id === currentUserCustomerId ||
  (Array.isArray(regions) && regions.length
    ? !!regions.filter(({ id }) => customerHydraFilter(customer, id, regions))
        .length
    : false);

export const instrumentFilter = (customer, selectedInstrumentId) => {
  return (
    !selectedInstrumentId || customer.instruments.includes(selectedInstrumentId)
  );
};

export const regionFilter = (profile, selectedAreaIds, selectedHydraId) => {
  return !profile
    ? true
    : selectedHydraId
    ? profile.regionId === selectedHydraId
    : selectedAreaIds.length
    ? selectedAreaIds.includes(profile.regionId)
    : true;
};

export const nameSearchFilter = (name, searchValue) =>
  !searchValue ||
  (name && name.toLowerCase().includes(searchValue.toLowerCase()));

export const tenseFilter = (date, tense, selectedDate) =>
  !tense ||
  selectedDate ||
  (tense === 'CURRENT' && isTodayOrAfter(date)) ||
  (tense === 'PREVIOUS' && !isTodayOrAfter(date));

export const distanceBetween = (lat1, lon1, lat2, lon2) => {
  const R = 3958.756; // miles
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
  // return Math.round(R * c);
};

export const dateFilter = (date, start, end, startEndRawFormat) => {
  if (!start) return true;
  if (!date) return false;
  const dateMoment = getMoment({ date, rawFormat: 'YYYY-MM-DD' });
  const startDate = getMoment({ date: start, rawFormat: startEndRawFormat });
  const endDate = end
    ? getMoment({ date: end, rawFormat: startEndRawFormat })
    : getMoment({ date: start, rawFormat: startEndRawFormat });
  return endDate.isSameOrAfter(startDate)
    ? dateMoment.isSameOrAfter(startDate) && dateMoment.isSameOrBefore(endDate)
    : dateMoment.isSameOrAfter(startDate);
};

export const isTimeEndBeforeStart = (time, end, rawFormat = 'HH:mm:ss a') =>
  !time
    ? true
    : !end
    ? false
    : getMoment({ date: end, rawFormat }).isBefore(
        getMoment({ date: time, rawFormat })
      );

export const timeFilter = (time, timeEnd, start, end, startEndRawFormat) => {
  if (!start) return true;
  if (!time) return false;
  const timeMoment = getMoment({ date: time, rawFormat: 'HH:mm:ss a' });
  const timeEndMoment = timeEnd
    ? getMoment({ date: timeEnd, rawFormat: 'HH:mm:ss a' })
    : timeMoment.add(1, 'second');
  const startTime = getMoment({ date: start, rawFormat: startEndRawFormat });
  const endTime = end
    ? getMoment({
        date: end,
        rawFormat: startEndRawFormat
      })
    : moment(startTime).add(1, 'hours');
  return moment
    .range(timeMoment, timeEndMoment)
    .overlaps(moment.range(startTime, endTime.add(2, 'second')));
};

export const isLive = (date, time, timeEnd, timezone) => {
  const start = `${date.split('T')[0]}T${time}${moment
    .tz(timezone)
    .format('Z')}`;
  let end = timeEnd
    ? `${date.split('T')[0]}T${timeEnd}${moment.tz(timezone).format('Z')}`
    : moment(start).add(2, 'h');
  end = moment(end) > moment(start) ? end : moment(end).add(24, 'h');

  return moment().within(moment.range(start, end));
};

export const isNew = date => moment(date).isAfter(moment().subtract(5, 'days'));

export const copyToClipboard = text => {
  if (navigator) {
    navigator.clipboard.writeText(text);
  }
};

export const distanceLatLong = (lat1, lon1, lat2, lon2) => {
  // Yes, those variable names are valid...
  const R = 6371e3; // metres
  const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c; // in metres
  return d;
};

export const filenameDateTime = d => moment(d).format('YYYYMMDDHHmmss');
export const dbDateTime = d => moment(d).format('YYYY-MM-DD HH:mm:ss');
export const dbDate = d => moment(d).format('YYYY-MM-DD');
export const displayDateTime = d => moment(d).format('DD/MM/YYYY HH:mm:ss');
export const jsDateTime = d => moment(d).format('MM/DD/YYYY HH:mm:ss');

export const isSafari = () => {
  return (
    navigator.userAgent.indexOf('Safari') !== -1 &&
    navigator.userAgent.indexOf('Chrome') === -1
  );
};

export const cloudLogLink = (datetime, phalanxRef) => {
  if (!phalanxRef) return '';

  const project = Config.Local().environment === 'production' ? 'trojan-tcs-csms-prod' : 'trojan-tcs-csms-dev';
  const hydraRef = phalanxRef.split('_cs_')[0];
  const csId = 'cs_' + phalanxRef.split('_cs_')[1];

  const from_time = moment
    .utc(datetime.replace('T', ' ').split(',')[0])
    .local()
    .subtract(2, 'minutes')
    .format('YYYY-MM-DDTHH:mm:ss.000Z');
  const to_time = moment
    .utc(datetime.replace('T', ' ').split(',')[0])
    .local()
    .add(2, 'minutes')
    .format('YYYY-MM-DDTHH:mm:ss.000Z');
  // '2023-02-20T13:21:30.000Z';
  const event_time = datetime.replace(',', '');

  return `https://console.cloud.google.com/logs/query;query=%2528-protoPayload.status%3D200%20OR%0A-httpRequest.status%3D200%2529%0A-httpRequest.userAgent%3D%22GoogleHC%2F1.0%22%0A${hydraRef}%20AND%20${csId};timeRange=${from_time}%2F${to_time};cursorTimestamp=${event_time};startTime=${from_time};endTime=${to_time}?project=${project}`;
};

// Location
export const startGeoLocationWatch = (setCurrentPosition, positionError) => {
  if (!global.geoWatch) {
    if (
      'geolocation' in navigator &&
      'watchPosition' in navigator.geolocation
    ) {
      global.geoWatch = navigator.geolocation.watchPosition(
        setCurrentPosition,
        positionError,
        {
          enableHighAccuracy: false,
          timeout: 15000,
          maximumAge: 0
        }
      );
    }
  }
};

export const stopGeoLocationWatch = () => {
  navigator.geolocation.clearWatch(global.geoWatch);
  global.geoWatch = undefined;
};

export const commandToText = s => {
  let s2 = s.toLowerCase().replaceAll('_', ' ');
  return s2.charAt(0).toUpperCase() + s2.slice(1);
};

export const isV2LanceID = id => {
  if (!id) return false;

  const intId = Math.floor(Number(id));
  if (intId === Infinity) return false;

  return intId >= 30001000;
};

export const displayLanceID = (id, version) => {
  if (!id) return '';

  const intId = Math.floor(Number(id));
  if (intId === Infinity) return '?';

  return `${intId} (${version})`;
};

// Polyfills
export const polyFillStructuredClone = obj => {
  let copy = null;
  if (typeof structuredClone === 'undefined')
    copy = JSON.parse(JSON.stringify(obj));
  else copy = structuredClone(obj);
  return copy;
};

export const linkifyText = txt => {
  return txt.split(' ').map(s => {
    const project = Config.Local().environment === 'production' ? 'trojan-tcs-csms-prod' : 'trojan-tcs-csms-dev';

    const parts = s.split('#');
    if (parts.length === 1) return s + ' ';

    const linkTxt = parts[0];
    let linkId = parts[1];
    // Strip punctuation which can break links
    // linkId = linkId.replace(/,/g, '').replace(/./g, '');

    // Orion ticket
    if (linkId.startsWith('ORTK'))
      return (
        <>
          <a target='_blank' rel='noopener noreferrer' href={`https://portal-orion-dot-${project}.nw.r.appspot.com/orion/ticket/` + linkId}>{linkTxt}</a>{' '}
        </>
      );
    // Customer
    if (linkId.startsWith('CCCR'))
      return (
        <>
          <a target='_blank' rel='noopener noreferrer' href={`${Config.Local().portal_url}/admin/customer/` + linkId}>{linkTxt}</a>{' '}
        </>
      );
    // Charging session
    if (linkId.startsWith('MMSN'))
      return (
        <>
          <a target='_blank' rel='noopener noreferrer' href={`${Config.Local().portal_url}/admin/session/` + linkId}>{linkTxt}</a>{' '}
        </>
      );
    // Hydra/HUB
    if (linkId.startsWith('HMATG'))
      return linkTxt + ' ';
    // HUB
    if (linkId.startsWith('HUB'))
      return (
        <>
          <a target='_blank' rel='noopener noreferrer' href={`${Config.Local().portal_url}/admin/hubs/` + linkId.substring(3)}>{linkTxt}</a>{' '}
        </>
      );
    // Phalanx
    if (linkId.startsWith('PMATG'))
      return linkTxt + ' ';
    if (linkId.startsWith('MATG'))
      return linkTxt + ' ';
    // CS
    if (linkId.startsWith('CS')) {
      const bits = linkId.substring(2).split('_cs');
      const hubRef = bits[0];
      const csId = 'cs' + bits[1];

      return (
        <>
          <a target='_blank' rel='noopener noreferrer' href={`${Config.Local().portal_url}/admin/hubs/${hubRef}/${csId}`}>{linkTxt}</a>{' '}
        </>
      );
    };

    // MMSL - meter sessionlet
    // MXRG - meter reading
    // LMATG - lance
    // CUUR - User

    return linkTxt + ' ';
  });
};

export const deLinkifyText = txt => {
  let newTxt = '';
  txt.split(' ').forEach((s, idx) => {
    newTxt += s.split('#')[0] + ' ';
  });
  return newTxt;
};
